module.exports = __webpack_public_path__ + "c390f25425061156b9e939f6340f5604.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-16-harrison/diary.jpg
// module id = 778
// module chunks = 0